module.exports = __webpack_public_path__ + "img/conduct.e06676d6.jpg";